<span (uClickOutside)="closeMobileMenu()" [attr.menu-open]="menuIsOpen">
  <button (click)="toggleMobileMenu()" aria-label="toggle menu">
    <fa-icon [icon]="['fal', 'bars']" size="2x" [attr.menu-open]="menuIsOpen"></fa-icon>
  </button>

  <u-menu-mobile src="menu" [attr.menu-open]="menuIsOpen" (forceClose)="closeMobileMenu()"></u-menu-mobile>
</span>

<div class="overlay">&nbsp;</div>
